(function (window, document, $) {

    $(document).ready(function () {
        // =======================================================================================================
        // Check if div is too small, then hide 
        if ($('.widget_blendle').length && $('.widget_blendle').height() < 20) {
            $('.widget_blendle').parent().addClass('hide');
        }

        if ($('.widget_instagram').length && $('.widget_instagram').height() < 20) {
            $('.widget_instagram').parent().addClass('hide');
        }
    });

}(window, document, jQuery));
